import type {CreateExtArgs} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import type {ComponentsMetadataAPI} from '../../../componentsMetadata/componentsMetadata'
import type {DataModelExtensionAPI} from '../../../dataModel/dataModel'
import {DATA_TYPES, COMP_TYPES} from '../../../../constants/constants'
import {getComponentType} from '../../../../utils/dalUtils'
import {getUniqueDisplayedId, isRepeatedComponent} from '../../../../utils/repeaterUtils'

const getRepeatedItemPointer = (pointer: Pointer, itemId: string) => {
    return {...pointer, id: getUniqueDisplayedId(pointer.id, itemId)}
}

const isRemovingMobileInstanceOfDesktopComp = (createExtArgs: CreateExtArgs, compPointer: Pointer) => {
    const {pointers} = createExtArgs
    const {componentsMetadata} = createExtArgs.extensionAPI as ComponentsMetadataAPI
    return pointers.structure.isMobile(compPointer) && !componentsMetadata.isMobileOnly(compPointer)
}

const getRepeaterAncestor = (createExtArgs: CreateExtArgs, comp: Pointer) => {
    const {pointers, dal} = createExtArgs
    const structurePointers = isRepeatedComponent(comp.id)
        ? pointers.components ?? pointers.structure
        : pointers.structure
    return structurePointers.getAncestorByPredicate(
        comp,
        (ancestor: Pointer) => getComponentType(dal, ancestor) === COMP_TYPES.REPEATER
    )
}

export const repeaterBeforeRemove = (createExtArgs: CreateExtArgs, componentPointer: Pointer): void => {
    const {dal, extensionAPI} = createExtArgs
    const {dataModel} = extensionAPI as DataModelExtensionAPI

    if (isRemovingMobileInstanceOfDesktopComp(createExtArgs, componentPointer)) {
        return
    }

    const repeaterAncestor = getRepeaterAncestor(createExtArgs, componentPointer)
    if (repeaterAncestor) {
        const repeaterData = dataModel.components.getItem(repeaterAncestor, DATA_TYPES.data)
        const {items} = repeaterData
        const templateDataItemPointer = dataModel.components.getItemPointer(componentPointer, DATA_TYPES.data)
        const templateDesignItemPointer = dataModel.components.getItemPointer(componentPointer, DATA_TYPES.design)
        items.forEach((itemId: string) => {
            if (templateDataItemPointer && dal.has(templateDataItemPointer)) {
                const repeatedDataItemPointer = getRepeatedItemPointer(templateDataItemPointer, itemId)
                dataModel.removeItemRecursively(repeatedDataItemPointer)
            }

            if (templateDesignItemPointer && dal.has(templateDesignItemPointer)) {
                const repeatedDesignItemPointer = getRepeatedItemPointer(templateDesignItemPointer, itemId)
                dataModel.removeItemRecursively(repeatedDesignItemPointer)
            }
        })
    }
}
